import dynamic from 'next/dynamic';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useProjectUnits } from '@/hooks/queries/useProjectUnits';
import { useListing } from '@/hooks/queries/useListing';

const DevelopmentUnits = dynamic(() =>
  import('@/components/property-expose/DevelopmentUnits/DevelopmentUnits').then((mod) => mod.DevelopmentUnits),
);

export const DynamicDevelopmentUnits = () => {
  const { data: projectUnitsResponse } = useProjectUnits();
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { listing },
  } = useListing();
  if (!listing) return null;

  if (!projectUnitsResponse || projectUnitsResponse.listings.length === 0 || isUAExclusiveListingAndNotSignedIn) return null;

  return <DevelopmentUnits listing={listing} />;
};
